import { render, staticRenderFns } from "./Minibot.vue?vue&type=template&id=607c1330&"
import script from "./Minibot.vue?vue&type=script&lang=js&"
export * from "./Minibot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports